var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow (1) 1",
    clipPath: "url(#clip0_441_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3573 2.15054C13.3337 1.1269 11.674 1.1269 10.6504 2.15054C9.62673 3.17418 9.62673 4.83386 10.6504 5.8575L14.2963 9.50446H2.50349C1.1228 9.50446 0.00354004 10.6237 0.00354004 12.0044C0.00354004 13.3851 1.1228 14.5043 2.50349 14.5043H14.2963L10.6504 18.1503C9.62673 19.1739 9.62673 20.8336 10.6504 21.8572C11.674 22.8809 13.3337 22.8809 14.3573 21.8572L23.8572 12.3574C24.0524 12.1621 24.0524 11.8456 23.8572 11.6504L14.3573 2.15054Z",
    fill: "#4C0A82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_1415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.00354004 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPurple);
export default __webpack_public_path__ + "static/media/right-arrow-purple.bcb62defb77a75cd3d3a48065fc2e9e5.svg";
export { ForwardRef as ReactComponent };